import { gql } from '../types/generated';

export const GET_PIPELINE_CONFIGS = gql(`
  query getPipelineConfigs {
    pipelineConfigs {
      ...PipelineConfigFields
    }
  }
`);

export const GET_REGIONAL_PIPELINE_CONFIGS = gql(`
  query getRegionalPipelineConfigs {
    east: pipelineConfigs(region: EAST) {
      id
      region
      teamId
    }
    central: pipelineConfigs(region: CENTRAL) {
      id
      region
      teamId
    }
  }
`);

export const GET_PIPELINE_CONFIG_DETAIL = gql(`
  query getPipelineConfigDetail($teamId: Int!, $region: Region!) {
    pipelineConfigs(teamId: $teamId, region: $region) {
      ...PipelineConfigFields
    }
  }
`);
